module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 form-layout"
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, [(_vm.participant && (_vm.bookingItem || _vm.venue)) ? _c('div', {
    key: "venue-name",
    staticClass: "form-rows"
  }, [_c('div', {
    staticClass: "fields input readonly half left"
  }, [_c('label', {
    attrs: {
      "for": "venue_name"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$parent.locale.text_heading_venue)
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "name": "venue_name",
      "id": "venue_name",
      "readonly": ""
    },
    domProps: {
      "value": _vm.bookingItem.venue_name + ' (' + _vm.bookingItem.venue_town + ')'
    }
  }), _vm._v(" "), (_vm.package) ? _c('p', [_vm._v(_vm._s(_vm.$parent.locale.text_change_venue) + ", "), _c('a', {
    on: {
      "click": _vm.changeVenue
    }
  }, [_vm._v("click here")]), _vm._v(". " + _vm._s(_vm.$parent.locale.text_change_venue_participant_warning))]) : _vm._e()]), _vm._v(" "), (_vm.participant) ? _c('div', {
    staticClass: "fields input readonly half right"
  }, [_c('label', {
    attrs: {
      "for": "participant_name"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$parent.locale.text_heading_participant)
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "participant_name",
      "id": "participant_name",
      "readonly": ""
    },
    domProps: {
      "value": _vm.participant.first_name + ' ' + _vm.participant.last_name
    }
  }), _vm._v(" "), (_vm.package) ? _c('p', [_vm._v(_vm._s(_vm.$parent.locale.text_change_participant) + ", "), _c('a', {
    on: {
      "click": _vm.changeParticipant
    }
  }, [_vm._v("click here")]), _vm._v(". " + _vm._s(_vm.$parent.locale.text_change_venue_participant_warning))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.participant) ? _c('div', {
    key: "quick-weeks",
    staticClass: "form-rows form-section"
  }, [_c('week-selection', {
    attrs: {
      "quick": true,
      "participant": _vm.participant,
      "quickSelection": _vm.selection
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selection.week) ? _c('div', {
    key: "quick-programme",
    staticClass: "form-rows"
  }, [_c('programme-selection', {
    attrs: {
      "quick": true,
      "participant": _vm.participant,
      "quickSelection": _vm.selection,
      "package": _vm.package
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selection.base instanceof Object && _vm.selection.week != null && _vm.participant) ? _c('div', {
    key: "quick-package",
    staticClass: "form-rows form-section"
  }, [_c('package-selection', {
    attrs: {
      "quick": true,
      "edit": true,
      "toSwap": _vm.$parent.booking_item,
      "participant": _vm.participant,
      "quickSelection": _vm.selection
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e932024"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/QuickAdd/FullWeek.vue
// module id = 170
// module chunks = 0